import type { RoleCode } from '@/types';

export const PERMISSIONS = {
  CASHIER: ['store_admin', 'store_cashier'] as RoleCode[],
  INVENTORY_WRITE: ['store_admin'] as RoleCode[],
  INVENTORY_READ: ['store_admin', 'store_cashier'] as RoleCode[],
  REPLENISH: ['store_admin'] as RoleCode[],
  REFUND: ['store_admin'] as RoleCode[],
  CUSTOMER_EXPORT: ['store_admin'] as RoleCode[],
  TECHNICIAN_MANAGE: ['store_admin'] as RoleCode[],
  PROMOTION_APPLY: ['store_admin'] as RoleCode[],
  SETTLEMENT_VIEW: ['store_admin', 'hq_finance'] as RoleCode[],
  DASHBOARD: ['store_admin'] as RoleCode[],
  SCHEDULE: ['store_admin'] as RoleCode[],
  DETECTION_VIEW: ['store_admin', 'store_cashier', 'store_operator'] as RoleCode[],
  DEVICE_VIEW: ['store_admin', 'store_cashier'] as RoleCode[],
};

export function hasAny(userRoles: RoleCode[], allowed: RoleCode[]): boolean {
  if (allowed.length === 0) return true;
  return userRoles.some((r) => allowed.includes(r));
}
